/* eslint-disable */
import React from 'react'
import Fade from 'react-reveal/Fade';
import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";

import CardLong from '../../components/card-long'
import IcWhy from '../../static/icons/halo-clean/ic-flexi.svg'
import IcHome from '../../static/icons/halo-clean/ic-price.svg'
import IcClock from '../../static/icons/halo-clean/ic-quality.svg'
import IcMap from '../../static/icons/halo-clean/ic-trust.svg'
import { TitleOne, TextBodyOne, BorderText } from '../../components/text'
import { Style } from './why-massage.styles'

const WhyHaloMassage = () => {
  const { t } = useTranslation();

  return (
    <Style id="why-massage">
      <Grid>
        <Row>
          <Col sm={12} xs={12} lg={12} className="bottom-margin-column">
            <TitleOne className="title-one" display="block" align="center">
              {t('pageJasaCleaningService.part5')}
            </TitleOne>
            <TextBodyOne
              className="title-body-one"
              display="block"
              align="center"
            >
              {t('pageJasaCleaningService.part6')}
            </TextBodyOne>
            <div className="border">
              <Fade left>
                <BorderText background="linear-gradient(261deg, #4af791, #98caed)"></BorderText>
              </Fade>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={6} xs={12} lg={6} className="bottom-margin">
            <CardLong
              border="#4af791"
              shadow="rgba(74, 247, 145, 0.1)"
              imageSize="120px"
              hover
              options={{
                image: IcWhy,
                title: t('pageJasaCleaningService.part7'),
                desc: t('pageJasaCleaningService.part8')
              }}
            ></CardLong>
          </Col>
          <Col sm={12} md={6} xs={12} lg={6} className="bottom-margin">
            <CardLong
              border="#4af791"
              shadow="rgba(74, 247, 145, 0.1)"
              imageSize="120px"
              hover
              options={{
                image: IcHome,
                title: t('pageJasaCleaningService.part9'),
                desc: t('pageJasaCleaningService.part10')
              }}
            ></CardLong>
          </Col>
          <Col sm={12} md={6} xs={12} lg={6} className="bottom-margin">
            <CardLong
              border="#4af791"
              imageSize="120px"
              shadow="rgba(74, 247, 145, 0.1)"
              hover
              options={{
                image: IcMap,
                title: t('pageJasaCleaningService.part11'),
                desc: t('pageJasaCleaningService.part12')
              }}
            ></CardLong>
          </Col>

          <Col sm={12} md={6} xs={12} lg={6} className="bottom-margin">
            <CardLong
              border="#4af791"
              imageSize="120px"
              shadow="rgba(74, 247, 145, 0.1)"
              hover
              options={{
                image: IcClock,
                title: t('pageJasaCleaningService.part13'),
                desc: t('pageJasaCleaningService.part14')
              }}
            ></CardLong>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default WhyHaloMassage
